import { getFavouriteIcon, getVendorCost, getVendorCostCategory, placeholderSrc } from "../../helpers";
import { Fragment } from "preact";
import { useEffect } from "preact/hooks";

import style from "./VendorTile.css";

const VendorTile = ({ isHorizontal, vendor, onFavouriteVendor, tileId, isCompact }) => {
  useEffect(() => {
    new Carousel({
      init: true,
      vendorId: vendor.id,
      element: "carousel_" + tileId, // id of the carousel container
      autoplay: false, // starts the rotation automatically
      infinite: false, // enables infinite scrolling (last index -> first)
      interval: 1500, // interval between slide changes
      initial: 0, // slide to start with
      dots: true, // show navigation dots
      arrows: true, // show navigation arrows
      buttons: false, // hide <play>/<stop> buttons,
      btnStopText: "Pause", // <stop> button text
    });
    /** lazyLoadInstance is for the lazy loading library;
     * lazyLoadVendorInstance is for vendorViewed events
     */
    if (window.lazyLoadInstance) window.lazyLoadInstance.update();
    if (window.lazyLoadVendorInstance) window.lazyLoadVendorInstance.update();
  }, []);

  const getCost = () => {
    let cost = getVendorCost(vendor);
    let costCategory = getVendorCostCategory(vendor);
    if (cost) {
      const costCategoryString = "€".repeat(costCategory);
      return (
        <Fragment>
            <span class={style.vendorTileCost}>{costCategoryString}</span>
        </Fragment>
      )
    }
    return <span class={style.inquire}>Preis: auf Anfrage</span>;
  };

  const vendorTileStyle = () =>
    isHorizontal ? style.horizontalVendorTile : style.verticalVendorTile;
  const vendorTileId = () =>
    isHorizontal ? '' : 'verticalVendorTile'

  const handleFavourite = (e, vendor) => {
    e.preventDefault();
    if (vendor.favourited) {
      return;
    }
    onFavouriteVendor(vendor);
  };

  const renderImages = () => {
    // return (
    //   <ul>
    //     <li key={vendor.id}>
    //       <img
    //         class={`${style.vendorImageBackground}`}
    //         src='/assets/images/image26.png'
    //       />
    //     </li>
    //   </ul>
    // );
    if (vendor.gallery) {
      let galleryImages =
        vendor.gallery.length > 10
          ? vendor.gallery.slice(0, 10)
          : vendor.gallery;

      if (galleryImages.length > 1) {
        return (
          <ul>
            {galleryImages.map((image, index) => {
              return (
                <li key={index}>
                  <img
                    class={`lazy ${style.vendorImageBackground}`}
                    src={placeholderSrc(300, 300)}
                    data-src={`https://cdn.weddyplace.com/resize/500/${image}`}
                    alt={`${vendor.title}-image`}
                  />
                </li>
              );
            })}
          </ul>
        );
      }
      return (
        <ul>
          <li key={vendor.id}>
            <img
              class={`lazy hidden ${style.vendorImageBackground}`}
              data-src={`https://cdn.weddyplace.com/resize/500/${vendor.headerImgSrc}`}
              src={placeholderSrc(300, 300)}
              alt={`${vendor.title}-image`}
              style={{ objectFit: "cover" }}
            />
          </li>
        </ul>
      );
    }
  };

  const handleHover = () => {
    if (vendor.highlightMarker) {
      vendor.highlightMarker();
    }
  };

  const handleStopBounce = () => {
    if (vendor.stopBounce) {
      vendor.stopBounce();
    }
  };

  // If a vendor isTop he should get both - PREMIUM & TOP badge.
  const renderIsPremium = (isTop) => {
    if (isTop) return <div class={style.vendorTileTagPremium}>PREMIUM</div>;
    return null;
  };

  const renderIsTop = (isTop) => {
    if (isTop) return <div className={style.vendorTileTagItemAccent} style={{backgroundColor: vendor.isTop ? '#F86D70' : '#007B90' }}>TOP</div>;
    return null;
  };
  
  const renderIsFast = (isFast) => {
    if (isFast) return <div class={style.vendorTileTagItem}>SCHNELLE&nbsp;RÜCKMELDUNG</div>;
    return null;
  };

  const getDistance = (distance) => {
    return Math.floor(distance / 1000);
  };

  const getCapacity = (maxGuests) => {
    if (maxGuests)
      return (
        <span class={style.capacityInquire}>
          Kapazität: {vendor.maxGuests} Gäste
        </span>
      );
    return "Kapazität: auf Anfrage";
  };

  const navigateToVendor = (e) => {
    e.preventDefault();
    const searchUrl = new URL(window.location.href);
    searchUrl.hash = vendor.id;
    window.history.replaceState({}, '', searchUrl.toString());
    // alert('')
    window.location.href = `/vendors/${vendor.slug}`;
  };

  const preventDefault = (e) => {
    e.preventDefault();
  }

  return (
    <div
      className={`${isHorizontal ? style.vendorContainerHorizontal : style.vendorContainer} ${isCompact ? style.compact : ''}`}
      data-top={vendor.isTop}
      onMouseEnter={handleHover}
      onMouseLeave={handleStopBounce}
    >
      <div
        data-id={tileId.replaceAll('-infoWindow', '')}
        data-lazy-function="vendorViewed"
        class={style.vendorTile + " lazyVendors"}
      >
        <a href={`/vendors/${vendor.slug}`} class={vendorTileStyle()} id={vendorTileId()} onClick={(e) => preventDefault(e)}>
          <div class={style.vendorImageBackgroundHolder}>
            <div class={style.vendorTileTagsContainer}>
              {renderIsPremium(vendor.isTop)}
              {renderIsTop(vendor.isTop)}
              {renderIsFast(vendor.isFast)}

              {/* <div
                class={style.vendorFavouriteContainer}
                onClick={(e) => handleFavourite(e, vendor)}
              >
                <div class={getFavouriteIcon(vendor.favourited)}></div>
              </div> */}
            </div>
            <div
              class={style.vendorFavouriteContainer}
              id="favouritesButton"
              onClick={(e) => handleFavourite(e, vendor)}
            >
              <div class={getFavouriteIcon(vendor.favourited)}></div>
            </div>
            <div
              id={"carousel_" + tileId}
              class={"js-Carousel vendor"}
            >
              {renderImages()}
            </div>
          </div>
          <div class={style.vendorTileContent} id="vendorTileContent" onClick={(e) => navigateToVendor(e)}>
            <div class={style.vendorTileReviewLocation}>
              <div style="display: flex; align-items: center">
                
                <span class={style.vendorTileTopbar}>
                  <div class={style.vendorTileRatingStar} />
                  <span class={style.vendorTileRating}>{vendor.rating}</span>
                  <span class={style.vendorTileReviews}>({vendor.numberReviews} Bewertungen)</span><span>&nbsp;·&nbsp;</span><span>{vendor.city}&nbsp;</span><span class={style.vendorDistance}> +{getDistance(vendor.distance)} km</span>
                </span>
              </div>
            </div>

            <span class={style.vendorTileTitle}>{vendor.title}</span>
            <span class={style.vendorTileDescriptionTags}>{vendor.tagging.map(tag => tag.name.charAt(0).toUpperCase() + tag.name.slice(1)).join(' · ')}</span>
            <div class={style.vendorTilePriceCapacity}>
              <span class={style.vendorTileCostContainer}>{getCost()}</span>
              {
                vendor.category == 'locations' &&
                <div class={style.vendorTileCapactiy}>
                  {getCapacity(vendor.maxGuests)}
                </div>
              }
            </div>
          </div>
        </a>
      </div>
    </div>
  );
};

export { VendorTile };
